import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

const $Container = styled.div<{
  $isHorizontal?: boolean;
  $isFluid?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $isHorizontal }) => ($isHorizontal ? 'row' : 'column')};
  width: 100%;
  position: relative;
  align-items: ${({ $isHorizontal }) => ($isHorizontal ? 'center' : undefined)};
  gap: ${({ $isHorizontal }) => ($isHorizontal ? spacing('lg') : undefined)};

  &:not(:last-child) {
    margin-bottom: ${spacing('sm')};
  }

  & > div {
    width: ${({ $isFluid }) => ($isFluid ? '100%' : undefined)};
  }
`;

export default $Container;
